import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./user-management.actions"
import * as fromGraphql from "./user-management.graphql"
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";
import {map, switchMap} from "rxjs";
import {
  CREATE_POPSM_USER_MUTATION,
  GET_SYSTEM_ADMINISTRATORS,
  UPDATE_POPSM_USER_MUTATION
} from "./user-management.graphql";


@Injectable()
export class UserManagementEffects {
  createPopsmUsers = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createPopsmUsers),
    switchMap((action) => {
      return this.apollo
        .mutate({
          mutation: CREATE_POPSM_USER_MUTATION,
          fetchPolicy: 'network-only',
          variables: {
            input: action.input
          }
        })
        .pipe(
          map(({ data }: any) => {
            if (data) {
              const result: any = Object.values(data)[0];
              if (result?.response?.code == '9000') {
                this.store.dispatch(fromActions.upsertUserManagement({userManagement: result?.data?.adminProfile}));
                this.notificationService.successMessage('Created Successfully');
              } else {
                this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
              }
            }
          })
        )
    })
  ),{ dispatch: false })

  updatePopsmUsers = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updatePopsmUsers),
    switchMap((action) => {
      return this.apollo
        .mutate({
          mutation: UPDATE_POPSM_USER_MUTATION,
          fetchPolicy: 'network-only',
          variables: {
            input: action.input
          }
        })
        .pipe(
          map(({ data }: any) => {
            if (data) {
              const result: any = Object.values(data)[0];
              if (result?.response?.code == '9000') {
                this.store.dispatch(fromActions.upsertUserManagement({userManagement: result?.data?.adminProfile}));
                this.notificationService.successMessage('Updated Successfully');
              } else {
                this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
              }
            }
          })
        )
    })
  ),{ dispatch: false })

  getSystemAdministrator = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getSystemAdministrators),
    switchMap((action) => {
      return this.apollo
        .query({
          query: GET_SYSTEM_ADMINISTRATORS,
          fetchPolicy: 'network-only',
          variables: {
            filtering: action.filtering
          }
        }).pipe(
          this.notificationService.catchError("Error occurred while fetching users"),
          map(({ data }: any ) => {
            if(data){
              const result: any = Object.values(data)[0]
              result?.response?.status ? this.store.dispatch(fromActions.loadUserManagements({userManagements: result?.data})) : []
            }
          })
        )
    })
  ), { dispatch: false })

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService) {
  }
}
